module.exports = "pegasus/assets/styleGroup2-facebook.png";